import axios from "./axios";
import { apiUrl } from "../config/crud";

const API_URL = apiUrl;
const USERS = "/user";

export function getUserById() {
	return axios.get(API_URL + USERS + "/");
}
